import AwesomeDebouncePromise from 'awesome-debounce-promise'
import { useMemo } from 'react'

import { SearchFieldBaseOption } from 'src/Libs/inputs/formik/SearchFieldBase'
import { fetchUsersWithConnections } from '../api/user.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

interface UseFilteredUserOptions {
  fetchFilteredUsers: (filterString: string, maxDisplayedResultCount?: number) => Promise<SearchFieldBaseOption[]>
}

/**
 * Hook that returns a function to get user options filtered by a given string inside the BE
 * @param filterString
 * @returns
 */
export const useFilteredUserOptions = (additionalFilter?: string): UseFilteredUserOptions => {
  const authFetch = useAuthFetchWithResponse()

  const getFilteredUserOptions = async (
    filterString: string,
    maxDisplayedResultCount?: number
  ): Promise<{ value: number; inputLabel: string; optionLabel: string }[]> => {
    const users = await fetchUsersWithConnections(
      {
        filterOr: `user.username=*${filterString}*,location.Email=*${filterString}*,fullName=*${filterString}*`,
        connect: 'location',
        fields: 'user.level,user.ID,user.username,location.Email,user.Vorname,user.Name',
        filter: additionalFilter,
      },
      authFetch
    )

    return (users?.value ?? []).slice(0, maxDisplayedResultCount).map(user => {
      const surname = user?.['user.Vorname'] ?? ''
      const name = user?.['user.Name'] ?? ''
      const userName = user?.['user.username'] ?? ''
      const email = user?.['location.Email'] ?? ''
      const id = user?.['user.ID']

      return {
        inputLabel: userName,
        optionLabel: `${userName} - ${surname} ${name} - ${email}`,
        value: id,
      }
    })
  }

  const fetchFilteredUsers = useMemo(
    () => AwesomeDebouncePromise(getFilteredUserOptions, 500),
    [] //eslint-disable-line
  )

  return { fetchFilteredUsers }
}
